import { LG } from "constants/sizes";
import titleDefaultProps from "segments/desktop/core-components/title/default-props";

export default {
  ...titleDefaultProps,
  textAlign: "left",
  titleSize: LG
};
